<template>
  <div class="edit_channel_diag">
    <simple-diag
      :isShow="isShow"
      :okText="okText"
      :cancelText="cancelText"
      width="700px"
      title=""
      @confirm="confirm"
      @close="close"
      @hide="hide"
    >
      <!-- tab -->
      <div class="edit_channel_wrap">
      <div class="edit_channel_tabs">
        <div class="edit_channel_tab" :class="{'edit_channel_tab_active': curStep === 'step1'}" @click="curStep='step1'">基本信息</div>
        <div class="edit_channel_tab" :class="{'edit_channel_tab_active': curStep === 'step2'}" @click="curStep='step2'">结算规则</div>
        <div class="close_wrap">
            <span class="close_icon" @click="close"></span>
        </div>
      </div>
       <!-- 步骤1 -->
      <div class="diag_step1_area" v-show="curStep === 'step1'">
        <div class="part_title1">基本信息</div>
        <div class="step1_item">
          <div class="step1_item_label"><span class="req">*</span>渠道名称:</div>
          <div class="step1_item_msg">{{addParams.agent_name}}</div>
        </div>

        <div class="step1_item">
          <div class="step1_item_label"><span class="req">*</span>平台LOGO:</div>
          <yjh-upload
            v-if="isShow"
            ref="yjhUpload"
            :url="baseAPI + '/invoice/do_add'"
            :stopUpload="true"
            :max="10"
            :fileType="['JPG', 'JPEG', 'PNG', 'BMP']"
            width="352px"
            comType="channel"
            :hasScan="true"
            overSizeToast="上传文件大小不能超过10M"
            @beforeUpload="handleUpload"
          ></yjh-upload>
        </div>

        <div class="step1_item">
          <div class="step1_item_label"><span class="req">*</span>工业注册链接:</div>
          <div class="step1_item_msg">{{addParams.link_industry || ''}}</div>
        </div>

        <div class="step1_item">
          <div class="step1_item_label"><span class="req">*</span>服务商注册链接:</div>
          <div class="step1_item_msg">{{addParams.link_service || ''}}</div>
        </div>

        <div class="step1_item">
          <div class="step1_item_label"><span class="req">*</span>运营后台链接:</div>
          <div class="step1_item_msg">{{addParams.link_manage || ''}}</div>
        </div>
        <div class="part_title2">收款账号  <span class="rule_name_error">{{ruleError}}</span></div>
        <table class="rule_name_table">
          <thead>
            <tr>
              <th width="70px"><span class="req">*</span>交易类型</th>
              <th width="170px"><span class="req">*</span>户名</th>
              <th width="170px"><span class="req">*</span>开户行</th>
              <th width="190px"><span class="req">*</span>收款账号</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in tableExtraInfo" :key="index">
              <td class="td_weight">{{item.label}}</td>
              <td><Input v-model="item.name" placeholder="请输入户名" @on-blur="singleBlur(index, 'name')"/></td>
              <td><Input v-model="item.bank" placeholder="请输入开户行" @on-blur="singleBlur(index, 'bank')"/></td>
              <td><Input v-model="item.custNo" placeholder="请输入收款账号" @on-blur="singleBlur(index, 'custNo')"/></td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- 步骤2 -->
      <div class="diag_step2_area" v-show="curStep === 'step2'">
         <table  class="add_rule_table">
          <thead>
            <tr>
              <th width="80px">序号</th>
              <th width="160px">交易类型</th>
              <th width="160px">子类型</th>
              <th width="200px">底价单价(元)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in rulePrices" :key="index">
              <td v-if="item.rowspan" :rowspan="item.rowspan">{{item.no}}</td>
              <td v-if="item.rowspan" :rowspan="item.rowspan">{{item.type}}</td>
              <td>{{item.subType}}</td>
              <td>
                <Input v-model.trim="item.price" style="width: 100px; position: relative; top: 7px;"
                  @keyup.native="item.price=item.price.replace(/[^\d^\.]+/g, '').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^\./g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')"
                  @on-blur="rulePriceCheck(index)"
                />
                <span style="color: #DC1818; font-size: 12px; margin-left: 10px;">{{item.error}}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      </div>
    </simple-diag>
  </div>
</template>
<script>
import simpleDiag from '@/components/dialogs/simpleDiag.vue'
import yjhUpload from '@/components/yjhUpload'

import { saveChannelEdit, channelEditInfo } from '@/api/channel'
export default {
  name: 'editChannelDiag',
  components: {
    simpleDiag,
    yjhUpload
  },
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      curStep: 'step1', // 当前步骤
      uuid: '',
      filename: '', // 图片名字
      addParams: {
        agent_name: '', // 渠道名称
        file: '', // 平台LOGO
        filesrc: '', // 编辑的时候才使用
        link_industry: '', // 工业注册链接
        link_service: '', // 服务商注册链接
        link_manage: '' // 运营后台链接
      },
      ruleError: '',
      tableExtraInfo: [
        {
          label: '会员交易',
          name: '',
          bank: '',
          custNo: '',
          nameError: '',
          bankError: '',
          custNoError: ''
        },
        {
          label: '调研交易',
          name: '',
          bank: '',
          custNo: '',
          nameError: '',
          bankError: '',
          custNoError: ''
        },
        {
          label: '会议交易',
          name: '',
          bank: '',
          custNo: '',
          nameError: '',
          bankError: '',
          custNoError: ''
        }
      ],
      rulePrices: [ // 结算规则价格
        { no: 1, type: '会员交易', subType: '初级会员', price: '', rowspan: 3, error: '' },
        { no: 1, type: '会员交易', subType: '中级会员', price: '', rowspan: 0, error: '' },
        { no: 1, type: '会员交易', subType: '高级会员', price: '', rowspan: 0, error: '' },
        { no: 2, type: '调研交易', subType: '调研次数', price: '', rowspan: 2, error: '' },
        { no: 2, type: '调研交易', subType: '调研报告', price: '', rowspan: 0, error: '' },
        { no: 3, type: '会议交易', subType: '直播次数', price: '', rowspan: 5, error: '' },
        { no: 3, type: '会议交易', subType: '会议室1个月', price: '', rowspan: 0, error: '' },
        { no: 3, type: '会议交易', subType: '会议室3个月', price: '', rowspan: 0, error: '' },
        { no: 3, type: '会议交易', subType: '会议室6个月', price: '', rowspan: 0, error: '' },
        { no: 3, type: '会议交易', subType: '会议室1年', price: '', rowspan: 0, error: '' }
      ]
    }
  },
  computed: {
    baseAPI() {
      return process.env.VUE_APP_BASE_API
    },
    okText() {
      return '确定'
    },
    cancelText() {
      return '取消'
    }
  },
  watch: {
    isShow(val) {
      if (val) {
        this.ruleError = ''
        this.curStep = 'step1'
        this.setEditInfo()
      }
    }
  },
  methods: {
    // 选文件
    handleUpload(file) {
      this.addParams.file = file
    },
    confirm() {
      // 校验step1
      const tmpArr2 = []
      this.tableExtraInfo.map(obj => {
        if (obj.name === '') {
          tmpArr2.push('不能为空')
        }
        if (obj.bank === '') {
          tmpArr2.push('不能为空')
        }
        if (obj.custNo === '') {
          tmpArr2.push('不能为空')
        }
      })
      if (tmpArr2.length) {
        this.ruleError = '不能为空'
      } else {
        this.ruleError = ''
      }
      this.rulePrices.forEach((obj, index) => {
        if (obj.price === '' || Number(obj.price) > 999999) {
          this.$set(this.rulePrices[index], 'error', '输入区间值')
        } else {
          this.$set(this.rulePrices[index], 'error', '')
        }
      })
      const flag = this.rulePrices.some(obj => {
        return obj.error === '输入区间值'
      })
      if (this.ruleError === '不能为空' || flag) { // 二者选其一
        return
      }
      var formData = new FormData()
      formData.append('uuid', this.uuid)
      formData.append('agent_name', this.addParams.agent_name)
      if (this.addParams.file) { // 有则重新上传无则传回agent_logo_path
        formData.append('file', this.addParams.file)
      } else {
        formData.append('agent_logo_old_name', this.filename)
        formData.append('agent_logo_path', this.addParams.filesrc)
      }
      formData.append('link_industry', this.addParams.link_industry)
      formData.append('link_service', this.addParams.link_service)
      formData.append('link_manage', this.addParams.link_manage)
      formData.append('is_own', '0')
      // formData.append('t_agent_info_uuid', '')

      formData.append('hy_cust_name', this.tableExtraInfo[0].name) // 会员交易 0
      formData.append('hy_bank_name', this.tableExtraInfo[0].bank)
      formData.append('hy_bank_no', this.tableExtraInfo[0].custNo)

      formData.append('report_cust_name', this.tableExtraInfo[1].name) // 调研次数 1
      formData.append('report_bank_name', this.tableExtraInfo[1].bank)
      formData.append('report_bank_no', this.tableExtraInfo[1].custNo)

      formData.append('base_report_cust_name', this.tableExtraInfo[2].name) // 调研报告 未定
      formData.append('base_report_bank_name', this.tableExtraInfo[2].bank)
      formData.append('base_report_bank_no', this.tableExtraInfo[2].custNo)

      formData.append('live_cust_name', this.tableExtraInfo[2].name) // 直播场次 2
      formData.append('live_bank_name', this.tableExtraInfo[2].bank)
      formData.append('live_bank_no', this.tableExtraInfo[2].custNo)

      formData.append('meeting_cust_name', this.tableExtraInfo[2].name) // 会议交易 2
      formData.append('meeting_bank_name', this.tableExtraInfo[2].bank)
      formData.append('meeting_bank_no', this.tableExtraInfo[2].custNo)

      formData.append('money_hy_level_base', this.rulePrices[0].price)
      formData.append('money_hy_level_mid', this.rulePrices[1].price)
      formData.append('money_hy_level_adv', this.rulePrices[2].price)

      formData.append('money_config_report', this.rulePrices[3].price) // 调研交易-调研次数
      formData.append('money_config_base_report', this.rulePrices[4].price) // 调研交易-调研报告

      formData.append('money_config_live', this.rulePrices[5].price)
      formData.append('money_meeting_month_1', this.rulePrices[6].price)
      formData.append('money_meeting_month_3', this.rulePrices[7].price)
      formData.append('money_meeting_month_6', this.rulePrices[8].price)
      formData.append('money_meeting_year_1', this.rulePrices[9].price)
      saveChannelEdit(formData).then(res => {
        if (res.code === 0) {
          this.$Message.info('编辑成功')
          this.$emit('close')
          this.$emit('success')
        } else {
          this.$Message.info(res.msg)
        }
      })
    },
    close() {
      this.$emit('close')
    },
    setEditInfo() {
      this.uuid = this.editData.uuid || ''
      channelEditInfo({
        uuid: this.uuid
      }).then(res => {
        if (res.code === 0) {
          const { agent_ext_info, agent_info } = res.result
          this.filename = agent_info.agent_logo_old_name
          this.$refs.yjhUpload.setFileName({
            name: agent_info.agent_logo_old_name || '',
            url: agent_info.agent_logo_path_url
          })
          this.$set(this.addParams, 'agent_name', agent_info.agent_name || '')
          this.$set(this.addParams, 'file', '') // 置空流
          this.$set(this.addParams, 'filesrc', agent_info.agent_logo_path || '')
          this.$set(this.addParams, 'link_industry', agent_info.link_industry || '')
          this.$set(this.addParams, 'link_service', agent_info.link_service || '')
          this.$set(this.addParams, 'link_manage', agent_info.link_manage || '')

          this.$set(this.tableExtraInfo[0], 'name', agent_ext_info.hy_cust_name || '')
          this.$set(this.tableExtraInfo[0], 'bank', agent_ext_info.hy_bank_name || '')
          this.$set(this.tableExtraInfo[0], 'custNo', agent_ext_info.hy_bank_no || '')
          this.$set(this.tableExtraInfo[1], 'name', agent_ext_info.report_cust_name || '')
          this.$set(this.tableExtraInfo[1], 'bank', agent_ext_info.report_bank_name || '')
          this.$set(this.tableExtraInfo[1], 'custNo', agent_ext_info.report_bank_no || '')
          this.$set(this.tableExtraInfo[2], 'name', agent_ext_info.meeting_cust_name || '')
          this.$set(this.tableExtraInfo[2], 'bank', agent_ext_info.meeting_bank_name || '')
          this.$set(this.tableExtraInfo[2], 'custNo', agent_ext_info.meeting_bank_no || '')

          this.$set(this.rulePrices[0], 'price', agent_ext_info.money_hy_level_base || '')
          this.$set(this.rulePrices[1], 'price', agent_ext_info.money_hy_level_mid || '')
          this.$set(this.rulePrices[2], 'price', agent_ext_info.money_hy_level_adv || '')
          this.$set(this.rulePrices[3], 'price', agent_ext_info.money_config_report || '')
          this.$set(this.rulePrices[4], 'price', agent_ext_info.money_config_base_report || '')
          this.$set(this.rulePrices[5], 'price', agent_ext_info.money_config_live || '')
          this.$set(this.rulePrices[6], 'price', agent_ext_info.money_meeting_month_1 || '')
          this.$set(this.rulePrices[7], 'price', agent_ext_info.money_meeting_month_3 || '')
          this.$set(this.rulePrices[8], 'price', agent_ext_info.money_meeting_month_6 || '')
          this.$set(this.rulePrices[9], 'price', agent_ext_info.money_meeting_year_1 || '')
        }
      })
    },
    hide() {
      this.$emit('hide')
    },
    // 收款账号blur
    singleBlur(index, field) {
      if (this.tableExtraInfo[index][field] === '') {
        this.$set(this.tableExtraInfo[index], `${field}Error`, '不能为空')
      } else {
        this.$set(this.tableExtraInfo[index], `${field}Error`, '校验过')
      }
      const tmpArr = []
      this.tableExtraInfo.map(obj => {
        if (obj.nameError === '不能为空') {
          tmpArr.push(obj.nameError)
        }
        if (obj.bankError === '不能为空') {
          tmpArr.push(obj.bankError)
        }
        if (obj.custNoError === '不能为空') {
          tmpArr.push(obj.custNoError)
        }
      })
      if (tmpArr.length) {
        this.ruleError = '不能为空'
      } else {
        this.ruleError = ''
      }
    },
    rulePriceCheck(index) { // 结算规则校验
      // if (this.rulePrices[index].price !== '') {
      //   this.$set(this.rulePrices[index], 'price', Number(this.rulePrices[index].price).toFixed(2) + '')
      // }
      if (this.rulePrices[index].price === '' || Number(this.rulePrices[index].price > 999999)) {
        this.$set(this.rulePrices[index], 'error', '输入区间值')
      } else {
        this.$set(this.rulePrices[index], 'error', '')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/color.scss';
// /deep/ .ivu-icon-ios-close {
//   top: 5px;
// }
.edit_channel_wrap {
  position: relative;
}
.edit_channel_tabs {
  height: 40px;
  line-height: 40px;
  position: relative;
  top: -30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #D9E2EF;
  &:after {
    content: '';
    display: block;
    width: 20px;
    height: 1px;
    background: #D9E2EF;
    position: absolute;
    left: -20px;
    top: 39px;
  }
  &:before {
    content: '';
    display: block;
    width: 20px;
    height: 1px;
    background: #D9E2EF;
    position: absolute;
    right: -20px;
    top: 39px;
  }
  .edit_channel_tab {
    cursor: pointer;
    margin: 0 60px;
    font-weight: 400;
  }
  .edit_channel_tab_active {
    color: $blue;
    font-weight: 600;
    position: relative;
    &:after {
      content: '';
      display: block;
      width: 100%;
      position: absolute;
      height: 2px;
      background: $blue;
      bottom: 0px;
    }
  }
  .close_wrap {
    position: absolute;
    width: 10px;
    height: 22px;
    right: 0px;
    top: 10px;
    z-index: 70;
    background: #FFF;
    .close_icon {
      display: inline-block;
      height: 10px;
      width: 10px;
      position: absolute;
      top: 4px;
      background: url('~@/assets/icon.svg') no-repeat -354px -134px;
      cursor: pointer;
    }
  }
}
.diag_step1_area {
  position: relative;
  padding-top: 16px;
  height: 462px;
  .part_title1 {
    position: absolute;
    top: -13px;
    padding-left: 20px;
    font-size: 12px;
    line-height: 17px;
    color: #B5C2D0;
    font-weight: 400;
  }
  .part_title2 {
    padding-left: 20px;
    font-size: 12px;
    line-height: 17px;
    color: #B5C2D0;
    font-weight: 400;
    margin-top: 7px;
    position: relative;
    .rule_name_error {
      color: $red;
      position: absolute;
      right: 30px;
    }
  }
}
.step1_item {
   display: flex;
   align-items: center;
   justify-content: flex-start;
   margin-bottom: 20px;
  .step1_item_label {
    width: 135px;
    text-align: right;
    padding-right: 10px;
  }
  .step1_item_msg {
    width: 434px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.rule_name_table {
  margin: 12px 0 0 30px;
  width: 600px;
  border-collapse:collapse;
  border: 1px solid #DAE3EA;
  thead {
    tr {
      height: 30px;
      line-height: 30px;
      background: #DAE3EA;
      th {
        color: #5D6F80;
        font-weight: 500;
        padding: 0 0 0 10px;
        text-align: left;
      }
    }
  }
  tbody {
    tr {
      height: 42px;
      td {
        padding: 0 10px;
        text-align: center;
        border: 1px solid #DAE3EA;
        vertical-align: middle;
      }
      .td_weight {
        padding: 0 0 0 3px;
        font-weight: 500;
      }
    }
  }
}
.req {
  color: $red;
}
.add_rule_table {
  width: 600px;
  margin-left: 30px;
  border-collapse:collapse;
  border: 1px solid #DAE3EA;
  thead {
    tr {
      height: 30px;
      line-height: 30px;
      background: #DAE3EA;
      color: #5D6F80;
      font-weight: 500;
      th {
        text-align: left;
        padding: 0 10px;
      }
    }
  }
  tbody {
    tr {
      td {
        border: 1px solid #DAE3EA;
        height: 42px;
        line-height: 42px;
        vertical-align: middle;
        padding-left: 10px;
        color: #5D6F80;
        font-weight: 400;
      }
    }
  }
}
</style>
